import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { BitbucketLinkedService } from 'app/model/linkedservice/bitbucket.linkedservice';
import { TabularTypeDataset } from 'app/model/dataset/tabular-type.dataset';

@Metamodel.model({
    name: 'BitbucketTable',
    display: [],
    constraints: {
        linkedService: {
            model: BitbucketLinkedService.MODEL
        }
    }
})
export class BitbucketTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;
}
